
export enum TaskTypeEnum
{
	'' = '',
	'Task' = 1,
	'RingUp' = 2,
	'Meeting' = 3,
	'Housekeeping' = 4,
	'Delivery' = 5,
	'Vehicle Request' = 6,
	'Refund Request' = 300
}

export enum TaskSourceEnum
{
	NOTE = 1,
	RESERVATION = 2,
	GUEST = 3,
	QUOTE = 4,
	OWNER_LEAD = 5,
	OWNER_STATEMENT = 6,
	ONBOARDING = 7,
	MSG = 8,
	PROPERTY = 9
}

export enum TaskStatusEnum
{
	'Active' = 1,
	'Deferred' = 2,
	'Complete' = 3
}

export enum RepeatFreqEnum
{
	'Minute' = 1,
	'Hour' = 2,
	'Day' = 3,
	'Week' = 4,
	'Month' = 5,
	'Year' = 6
}

export enum PriorityEnum
{
	'Critical' = 1,
	'Immediate' = 2,
	'Important' = 3,
	'Standard' = 4,
	'Low' = 5
}

export enum PermissionsEnum
{
	'None' = 0,
	'User' = 100,
	'Super User' = 200,
	'Editor' = 300,
	'Super Editor' = 400,
	'Admin' = 500,
	'Super Admin' = 600
}
export enum NextActionEnum
{
	'None' = 0,
	'Call' = 1,
	'Call Back' = 2,
	'Event' = 3,
	'Follow Up' = 4,
	'No Action / FYI' = 5,
}

export enum Locations
{
	'Maui' = 1,
	'Park City' = 2,
	'Big Island' = 3,
	'Oahu' = 4,
	'San Diego' = 5,
	'Aspen' = 6,
	'Vail' = 7,
	'Sun Valley' = 8,
	'Bass Lake' = 9,
	'Yosemite' = 10,
	'Kauai' = 11,
	'East Bay Area (San Francisco)' = 12,
	'North Bay Area (San Francisco)' = 13,
	'South Bay Area (San Francisco)' = 14,
	'Penninsula Bay Area (San Francisco)' = 15,
}

export enum ListingStatus
{
	'Active' = 0,
	'Suspended' = 2,
	'Archived' = 1
}

export enum PropertyTypes
{
	'Single Family Home' = '14',
	'Condominium' = '01',
	'Townhome' = '16'
}

export enum ListingTypes
{
	'Short Term Rental' = 1,
	'Composite' = 2,
	'Hotel Room Type' = 3
}


export const PercentageValuesPositive =
	[
		{ value: 0.00, name: '0%' },
		{ value: 0.01, name: '1%' },
		{ value: 0.02, name: '2%' },
		{ value: 0.03, name: '3%' },
		{ value: 0.04, name: '4%' },
		{ value: 0.05, name: '5%' },
		{ value: 0.06, name: '6%' },
		{ value: 0.07, name: '7%' },
		{ value: 0.08, name: '8%' },
		{ value: 0.09, name: '9%' },
		{ value: 0.1, name: '10%' },
		{ value: 0.11, name: '11%' },
		{ value: 0.12, name: '12%' },
		{ value: 0.13, name: '13%' },
		{ value: 0.14, name: '14%' },
		{ value: 0.15, name: '15%' },
		{ value: 0.16, name: '16%' },
		{ value: 0.17, name: '17%' },
		{ value: 0.18, name: '18%' },
		{ value: 0.19, name: '19%' },
		{ value: 0.2, name: '20%' },
		{ value: 0.21, name: '21%' },
		{ value: 0.22, name: '22%' },
		{ value: 0.23, name: '23%' },
		{ value: 0.24, name: '24%' },
		{ value: 0.25, name: '25%' },
		{ value: 0.26, name: '26%' },
		{ value: 0.27, name: '27%' },
		{ value: 0.28, name: '28%' },
		{ value: 0.29, name: '29%' },
		{ value: 0.3, name: '30%' },
		{ value: 0.31, name: '31%' },
		{ value: 0.32, name: '32%' },
		{ value: 0.33, name: '33%' },
		{ value: 0.34, name: '34%' },
		{ value: 0.35, name: '35%' },
		{ value: 0.36, name: '36%' },
		{ value: 0.37, name: '37%' },
		{ value: 0.38, name: '38%' },
		{ value: 0.39, name: '39%' },
		{ value: 0.4, name: '40%' },
		{ value: 0.41, name: '41%' },
		{ value: 0.42, name: '42%' },
		{ value: 0.43, name: '43%' },
		{ value: 0.44, name: '44%' },
		{ value: 0.45, name: '45%' },
		{ value: 0.46, name: '46%' },
		{ value: 0.47, name: '47%' },
		{ value: 0.48, name: '48%' },
		{ value: 0.49, name: '49%' },
		{ value: 0.5, name: '50%' },
		{ value: 0.51, name: '51%' },
		{ value: 0.52, name: '52%' },
		{ value: 0.53, name: '53%' },
		{ value: 0.54, name: '54%' },
		{ value: 0.55, name: '55%' },
		{ value: 0.56, name: '56%' },
		{ value: 0.57, name: '57%' },
		{ value: 0.58, name: '58%' },
		{ value: 0.59, name: '59%' },
		{ value: 0.6, name: '60%' },
		{ value: 0.61, name: '61%' },
		{ value: 0.62, name: '62%' },
		{ value: 0.63, name: '63%' },
		{ value: 0.64, name: '64%' },
		{ value: 0.65, name: '65%' },
		{ value: 0.66, name: '66%' },
		{ value: 0.67, name: '67%' },
		{ value: 0.68, name: '68%' },
		{ value: 0.69, name: '69%' },
		{ value: 0.7, name: '70%' },
		{ value: 0.71, name: '71%' },
		{ value: 0.72, name: '72%' },
		{ value: 0.73, name: '73%' },
		{ value: 0.74, name: '74%' },
		{ value: 0.75, name: '75%' },
		{ value: 0.76, name: '76%' },
		{ value: 0.77, name: '77%' },
		{ value: 0.78, name: '78%' },
		{ value: 0.79, name: '79%' },
		{ value: 0.8, name: '80%' },
		{ value: 0.81, name: '81%' },
		{ value: 0.82, name: '82%' },
		{ value: 0.83, name: '83%' },
		{ value: 0.84, name: '84%' },
		{ value: 0.85, name: '85%' },
		{ value: 0.86, name: '86%' },
		{ value: 0.87, name: '87%' },
		{ value: 0.88, name: '88%' },
		{ value: 0.89, name: '89%' },
		{ value: 0.9, name: '90%' },
		{ value: 0.91, name: '91%' },
		{ value: 0.92, name: '92%' },
		{ value: 0.93, name: '93%' },
		{ value: 0.94, name: '94%' },
		{ value: 0.95, name: '95%' },
		{ value: 0.96, name: '96%' },
		{ value: 0.97, name: '97%' },
		{ value: 0.98, name: '98%' },
		{ value: 0.99, name: '99%' },
		{ value: 1, name: '100%' }
	] as const;

export const PercentageValuesNegative =
	[
		{ value: 0.00, name: '0%' },
		{ value: -0.01, name: '-1%' },
		{ value: -0.02, name: '-2%' },
		{ value: -0.03, name: '-3%' },
		{ value: -0.04, name: '-4%' },
		{ value: -0.05, name: '-5%' },
		{ value: -0.06, name: '-6%' },
		{ value: -0.07, name: '-7%' },
		{ value: -0.08, name: '-8%' },
		{ value: -0.09, name: '-9%' },
		{ value: -0.1, name: '-10%' },
		{ value: -0.11, name: '-11%' },
		{ value: -0.12, name: '-12%' },
		{ value: -0.13, name: '-13%' },
		{ value: -0.14, name: '-14%' },
		{ value: -0.15, name: '-15%' },
		{ value: -0.16, name: '-16%' },
		{ value: -0.17, name: '-17%' },
		{ value: -0.18, name: '-18%' },
		{ value: -0.19, name: '-19%' },
		{ value: -0.2, name: '-20%' },
		{ value: -0.21, name: '-21%' },
		{ value: -0.22, name: '-22%' },
		{ value: -0.23, name: '-23%' },
		{ value: -0.24, name: '-24%' },
		{ value: -0.25, name: '-25%' },
		{ value: -0.26, name: '-26%' },
		{ value: -0.27, name: '-27%' },
		{ value: -0.28, name: '-28%' },
		{ value: -0.29, name: '-29%' },
		{ value: -0.3, name: '-30%' },
		{ value: -0.31, name: '-31%' },
		{ value: -0.32, name: '-32%' },
		{ value: -0.33, name: '-33%' },
		{ value: -0.34, name: '-34%' },
		{ value: -0.35, name: '-35%' },
		{ value: -0.36, name: '-36%' },
		{ value: -0.37, name: '-37%' },
		{ value: -0.38, name: '-38%' },
		{ value: -0.39, name: '-39%' },
		{ value: -0.4, name: '-40%' },
		{ value: -0.41, name: '-41%' },
		{ value: -0.42, name: '-42%' },
		{ value: -0.43, name: '-43%' },
		{ value: -0.44, name: '-44%' },
		{ value: -0.45, name: '-45%' },
		{ value: -0.46, name: '-46%' },
		{ value: -0.47, name: '-47%' },
		{ value: -0.48, name: '-48%' },
		{ value: -0.49, name: '-49%' },
		{ value: -0.5, name: '-50%' },
		{ value: -0.51, name: '-51%' },
		{ value: -0.52, name: '-52%' },
		{ value: -0.53, name: '-53%' },
		{ value: -0.54, name: '-54%' },
		{ value: -0.55, name: '-55%' },
		{ value: -0.56, name: '-56%' },
		{ value: -0.57, name: '-57%' },
		{ value: -0.58, name: '-58%' },
		{ value: -0.59, name: '-59%' },
		{ value: -0.6, name: '-60%' },
		{ value: -0.61, name: '-61%' },
		{ value: -0.62, name: '-62%' },
		{ value: -0.63, name: '-63%' },
		{ value: -0.64, name: '-64%' },
		{ value: -0.65, name: '-65%' },
		{ value: -0.66, name: '-66%' },
		{ value: -0.67, name: '-67%' },
		{ value: -0.68, name: '-68%' },
		{ value: -0.69, name: '-69%' },
		{ value: -0.7, name: '-70%' },
		{ value: -0.71, name: '-71%' },
		{ value: -0.72, name: '-72%' },
		{ value: -0.73, name: '-73%' },
		{ value: -0.74, name: '-74%' },
		{ value: -0.75, name: '-75%' },
		{ value: -0.76, name: '-76%' },
		{ value: -0.77, name: '-77%' },
		{ value: -0.78, name: '-78%' },
		{ value: -0.79, name: '-79%' },
		{ value: -0.8, name: '-80%' },
		{ value: -0.81, name: '-81%' },
		{ value: -0.82, name: '-82%' },
		{ value: -0.83, name: '-83%' },
		{ value: -0.84, name: '-84%' },
		{ value: -0.85, name: '-85%' },
		{ value: -0.86, name: '-86%' },
		{ value: -0.87, name: '-87%' },
		{ value: -0.88, name: '-88%' },
		{ value: -0.89, name: '-89%' },
		{ value: -0.9, name: '-90%' },
		{ value: -0.91, name: '-91%' },
		{ value: -0.92, name: '-92%' },
		{ value: -0.93, name: '-93%' },
		{ value: -0.94, name: '-94%' },
		{ value: -0.95, name: '-95%' },
		{ value: -0.96, name: '-96%' },
		{ value: -0.97, name: '-97%' },
		{ value: -0.98, name: '-98%' },
		{ value: -0.99, name: '-99%' },
		{ value: -1, name: '-100%' }
	] as const;

export const PercentageValuesPositiveAndNegative =
	[
		{ value: -1, name: '-100%' },
		{ value: -0.99, name: '-99%' },
		{ value: -0.98, name: '-98%' },
		{ value: -0.97, name: '-97%' },
		{ value: -0.96, name: '-96%' },
		{ value: -0.95, name: '-95%' },
		{ value: -0.94, name: '-94%' },
		{ value: -0.93, name: '-93%' },
		{ value: -0.92, name: '-92%' },
		{ value: -0.91, name: '-91%' },
		{ value: -0.9, name: '-90%' },
		{ value: -0.89, name: '-89%' },
		{ value: -0.88, name: '-88%' },
		{ value: -0.87, name: '-87%' },
		{ value: -0.86, name: '-86%' },
		{ value: -0.85, name: '-85%' },
		{ value: -0.84, name: '-84%' },
		{ value: -0.83, name: '-83%' },
		{ value: -0.82, name: '-82%' },
		{ value: -0.81, name: '-81%' },
		{ value: -0.8, name: '-80%' },
		{ value: -0.79, name: '-79%' },
		{ value: -0.78, name: '-78%' },
		{ value: -0.77, name: '-77%' },
		{ value: -0.76, name: '-76%' },
		{ value: -0.75, name: '-75%' },
		{ value: -0.74, name: '-74%' },
		{ value: -0.73, name: '-73%' },
		{ value: -0.72, name: '-72%' },
		{ value: -0.71, name: '-71%' },
		{ value: -0.7, name: '-70%' },
		{ value: -0.69, name: '-69%' },
		{ value: -0.68, name: '-68%' },
		{ value: -0.67, name: '-67%' },
		{ value: -0.66, name: '-66%' },
		{ value: -0.65, name: '-65%' },
		{ value: -0.64, name: '-64%' },
		{ value: -0.63, name: '-63%' },
		{ value: -0.62, name: '-62%' },
		{ value: -0.61, name: '-61%' },
		{ value: -0.6, name: '-60%' },
		{ value: -0.59, name: '-59%' },
		{ value: -0.58, name: '-58%' },
		{ value: -0.57, name: '-57%' },
		{ value: -0.56, name: '-56%' },
		{ value: -0.55, name: '-55%' },
		{ value: -0.54, name: '-54%' },
		{ value: -0.53, name: '-53%' },
		{ value: -0.52, name: '-52%' },
		{ value: -0.51, name: '-51%' },
		{ value: -0.5, name: '-50%' },
		{ value: -0.49, name: '-49%' },
		{ value: -0.48, name: '-48%' },
		{ value: -0.47, name: '-47%' },
		{ value: -0.46, name: '-46%' },
		{ value: -0.45, name: '-45%' },
		{ value: -0.44, name: '-44%' },
		{ value: -0.43, name: '-43%' },
		{ value: -0.42, name: '-42%' },
		{ value: -0.41, name: '-41%' },
		{ value: -0.4, name: '-40%' },
		{ value: -0.39, name: '-39%' },
		{ value: -0.38, name: '-38%' },
		{ value: -0.37, name: '-37%' },
		{ value: -0.36, name: '-36%' },
		{ value: -0.35, name: '-35%' },
		{ value: -0.34, name: '-34%' },
		{ value: -0.33, name: '-33%' },
		{ value: -0.32, name: '-32%' },
		{ value: -0.31, name: '-31%' },
		{ value: -0.3, name: '-30%' },
		{ value: -0.29, name: '-29%' },
		{ value: -0.28, name: '-28%' },
		{ value: -0.27, name: '-27%' },
		{ value: -0.26, name: '-26%' },
		{ value: -0.25, name: '-25%' },
		{ value: -0.24, name: '-24%' },
		{ value: -0.23, name: '-23%' },
		{ value: -0.22, name: '-22%' },
		{ value: -0.21, name: '-21%' },
		{ value: -0.2, name: '-20%' },
		{ value: -0.19, name: '-19%' },
		{ value: -0.18, name: '-18%' },
		{ value: -0.17, name: '-17%' },
		{ value: -0.16, name: '-16%' },
		{ value: -0.15, name: '-15%' },
		{ value: -0.14, name: '-14%' },
		{ value: -0.13, name: '-13%' },
		{ value: -0.12, name: '-12%' },
		{ value: -0.11, name: '-11%' },
		{ value: -0.1, name: '-10%' },
		{ value: -0.09, name: '-9%' },
		{ value: -0.08, name: '-8%' },
		{ value: -0.07, name: '-7%' },
		{ value: -0.06, name: '-6%' },
		{ value: -0.05, name: '-5%' },
		{ value: -0.04, name: '-4%' },
		{ value: -0.03, name: '-3%' },
		{ value: -0.02, name: '-2%' },
		{ value: -0.01, name: '-1%' },
		{ value: 0.00, name: '0%' },
		{ value: 0.01, name: '1%' },
		{ value: 0.02, name: '2%' },
		{ value: 0.03, name: '3%' },
		{ value: 0.04, name: '4%' },
		{ value: 0.05, name: '5%' },
		{ value: 0.06, name: '6%' },
		{ value: 0.07, name: '7%' },
		{ value: 0.08, name: '8%' },
		{ value: 0.09, name: '9%' },
		{ value: 0.1, name: '10%' },
		{ value: 0.11, name: '11%' },
		{ value: 0.12, name: '12%' },
		{ value: 0.13, name: '13%' },
		{ value: 0.14, name: '14%' },
		{ value: 0.15, name: '15%' },
		{ value: 0.16, name: '16%' },
		{ value: 0.17, name: '17%' },
		{ value: 0.18, name: '18%' },
		{ value: 0.19, name: '19%' },
		{ value: 0.2, name: '20%' },
		{ value: 0.21, name: '21%' },
		{ value: 0.22, name: '22%' },
		{ value: 0.23, name: '23%' },
		{ value: 0.24, name: '24%' },
		{ value: 0.25, name: '25%' },
		{ value: 0.26, name: '26%' },
		{ value: 0.27, name: '27%' },
		{ value: 0.28, name: '28%' },
		{ value: 0.29, name: '29%' },
		{ value: 0.3, name: '30%' },
		{ value: 0.31, name: '31%' },
		{ value: 0.32, name: '32%' },
		{ value: 0.33, name: '33%' },
		{ value: 0.34, name: '34%' },
		{ value: 0.35, name: '35%' },
		{ value: 0.36, name: '36%' },
		{ value: 0.37, name: '37%' },
		{ value: 0.38, name: '38%' },
		{ value: 0.39, name: '39%' },
		{ value: 0.4, name: '40%' },
		{ value: 0.41, name: '41%' },
		{ value: 0.42, name: '42%' },
		{ value: 0.43, name: '43%' },
		{ value: 0.44, name: '44%' },
		{ value: 0.45, name: '45%' },
		{ value: 0.46, name: '46%' },
		{ value: 0.47, name: '47%' },
		{ value: 0.48, name: '48%' },
		{ value: 0.49, name: '49%' },
		{ value: 0.5, name: '50%' },
		{ value: 0.51, name: '51%' },
		{ value: 0.52, name: '52%' },
		{ value: 0.53, name: '53%' },
		{ value: 0.54, name: '54%' },
		{ value: 0.55, name: '55%' },
		{ value: 0.56, name: '56%' },
		{ value: 0.57, name: '57%' },
		{ value: 0.58, name: '58%' },
		{ value: 0.59, name: '59%' },
		{ value: 0.6, name: '60%' },
		{ value: 0.61, name: '61%' },
		{ value: 0.62, name: '62%' },
		{ value: 0.63, name: '63%' },
		{ value: 0.64, name: '64%' },
		{ value: 0.65, name: '65%' },
		{ value: 0.66, name: '66%' },
		{ value: 0.67, name: '67%' },
		{ value: 0.68, name: '68%' },
		{ value: 0.69, name: '69%' },
		{ value: 0.7, name: '70%' },
		{ value: 0.71, name: '71%' },
		{ value: 0.72, name: '72%' },
		{ value: 0.73, name: '73%' },
		{ value: 0.74, name: '74%' },
		{ value: 0.75, name: '75%' },
		{ value: 0.76, name: '76%' },
		{ value: 0.77, name: '77%' },
		{ value: 0.78, name: '78%' },
		{ value: 0.79, name: '79%' },
		{ value: 0.8, name: '80%' },
		{ value: 0.81, name: '81%' },
		{ value: 0.82, name: '82%' },
		{ value: 0.83, name: '83%' },
		{ value: 0.84, name: '84%' },
		{ value: 0.85, name: '85%' },
		{ value: 0.86, name: '86%' },
		{ value: 0.87, name: '87%' },
		{ value: 0.88, name: '88%' },
		{ value: 0.89, name: '89%' },
		{ value: 0.9, name: '90%' },
		{ value: 0.91, name: '91%' },
		{ value: 0.92, name: '92%' },
		{ value: 0.93, name: '93%' },
		{ value: 0.94, name: '94%' },
		{ value: 0.95, name: '95%' },
		{ value: 0.96, name: '96%' },
		{ value: 0.97, name: '97%' },
		{ value: 0.98, name: '98%' },
		{ value: 0.99, name: '99%' },
		{ value: 1, name: '100%' }
	] as const;

export const UserTitles =[
	{ name: 'Mr.', value: 'Mr.' },
	{ name: 'Mrs.', value: 'Mrs.' },
	{ name: 'Ms.', value: 'Ms.' },
	{ name: 'Dr.', value: 'Dr.' },
  ] as const;


